function getAllowedLanguages() {
    return ['de', 'en']
}

const configs = {
    getAllowedLanguages,
};

export default configs;
